import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

import api from "@/common/utils/api";
import { ErrorResponse } from "@reflag/shared/api";

export function useAdminUserDeleteMutation() {
  const queryClient = useQueryClient();

  return useMutation<object, AxiosResponse<ErrorResponse>, { userId: string }>({
    mutationKey: ["admin", "users", "delete"],
    mutationFn: (variables) =>
      api
        .delete<"/admin/users/:userId">(`/admin/users/${variables.userId}`)
        .then((res) => res.data),
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: ["admin", "users"] });
    },
  });
}
